var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#898F9D",
    width: "64px",
    height: "64px",
    viewBox: "-3.5 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.146 2.964v13.212a.476.476 0 0 1-.475.475H1.33a.476.476 0 0 1-.475-.475V2.964a.476.476 0 0 1 .475-.475h9.342a.476.476 0 0 1 .475.475zm-1.108.633H1.962v2.726h8.076zM3.653 8.608a.792.792 0 0 0-.791-.791h-.003a.792.792 0 1 0 0 1.583h.003a.792.792 0 0 0 .791-.792zm0 2.634a.792.792 0 0 0-.791-.791h-.003a.792.792 0 1 0 0 1.583h.003a.792.792 0 0 0 .791-.792zm0 2.634a.792.792 0 0 0-.791-.791h-.003a.792.792 0 1 0 0 1.583h.003a.792.792 0 0 0 .791-.792zm3.04-2.634a.792.792 0 0 0-.792-.791H5.9a.792.792 0 1 0 0 1.583.792.792 0 0 0 .792-.792zm0 2.634a.792.792 0 0 0-.792-.791H5.9a.792.792 0 1 0 0 1.583.792.792 0 0 0 .792-.792zm.048-5.268a.792.792 0 0 0-.791-.791h-.005a.792.792 0 0 0 0 1.583h.005a.792.792 0 0 0 .791-.792zm3.086 0a.792.792 0 0 0-.792-.791h-.002a.792.792 0 0 0 0 1.583h.002a.792.792 0 0 0 .792-.792zm0 2.587a.792.792 0 1 0-1.584 0v2.681a.792.792 0 0 0 1.584 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculator-icon.7f2db120ef191c2a6a096b1909bb5723.svg";
export { ForwardRef as ReactComponent };